import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  Alert,
  Tooltip,
  Snackbar,
  TextField,
  Chip,
  Tabs,
  Tab,
  Collapse,
  LinearProgress,
  Autocomplete,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RefreshIcon from '@mui/icons-material/Refresh';
import BugReportIcon from '@mui/icons-material/BugReport';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import HistoryIcon from '@mui/icons-material/History';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ChatIcon from '@mui/icons-material/Chat';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import StopIcon from '@mui/icons-material/Stop';
import AddCommentIcon from '@mui/icons-material/AddComment';
import SendIcon from '@mui/icons-material/Send';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialog, inputStyles } from './common';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

// Category color map
const CATEGORY_COLORS = {
  saludos: { gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', shadow: 'rgba(16, 185, 129, 0.4)', bg: '#10b981' },
  sintomas_no_salud: { gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', shadow: 'rgba(245, 158, 11, 0.4)', bg: '#f59e0b' },
  horarios: { gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)', shadow: 'rgba(14, 165, 233, 0.4)', bg: '#0ea5e9' },
  citas_absurdas: { gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', shadow: 'rgba(239, 68, 68, 0.4)', bg: '#ef4444' },
  servicios_no_medicos: { gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', shadow: 'rgba(139, 92, 246, 0.4)', bg: '#8b5cf6' },
  temas_irrelevantes: { gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)', shadow: 'rgba(236, 72, 153, 0.4)', bg: '#ec4899' },
  descontextualizadas_salud: { gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', shadow: 'rgba(6, 182, 212, 0.4)', bg: '#06b6d4' },
  pronombres_ambiguos: { gradient: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', shadow: 'rgba(99, 102, 241, 0.4)', bg: '#6366f1' },
  citas_lejanas: { gradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)', shadow: 'rgba(249, 115, 22, 0.4)', bg: '#f97316' },
  flujo_seguimiento: { gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', shadow: 'rgba(20, 184, 166, 0.4)', bg: '#14b8a6' },
  edge_cases: { gradient: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)', shadow: 'rgba(168, 85, 247, 0.4)', bg: '#a855f7' },
  conversacion_completa: { gradient: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)', shadow: 'rgba(220, 38, 38, 0.4)', bg: '#dc2626' },
};

const getCatColor = (cat) => CATEGORY_COLORS[cat] || { gradient: 'linear-gradient(135deg, #64748b 0%, #475569 100%)', shadow: 'rgba(100, 116, 139, 0.4)', bg: '#64748b' };

const ResultChip = ({ resultado, size = 'small' }) => {
  if (resultado === 'PASS') return <Chip icon={<CheckCircleIcon />} label="PASS" size={size} sx={{ bgcolor: '#d1fae5', color: '#065f46', fontWeight: 700, fontSize: 11, '& .MuiChip-icon': { color: '#10b981' } }} />;
  if (resultado === 'FAIL') return <Chip icon={<CancelIcon />} label="FAIL" size={size} sx={{ bgcolor: '#fee2e2', color: '#991b1b', fontWeight: 700, fontSize: 11, '& .MuiChip-icon': { color: '#ef4444' } }} />;
  if (resultado === 'WARN') return <Chip icon={<WarningAmberIcon />} label="WARN" size={size} sx={{ bgcolor: '#fef3c7', color: '#92400e', fontWeight: 700, fontSize: 11, '& .MuiChip-icon': { color: '#f59e0b' } }} />;
  return <Chip label="--" size={size} sx={{ bgcolor: '#f1f5f9', color: '#64748b', fontWeight: 600, fontSize: 11 }} />;
};

// Format a single test result for clipboard (to share with Claude)
const formatTestForClipboard = (test, result, chatbotName) => {
  let text = `## Test ${test.test_id}: ${test.nombre}\n`;
  text += `**Categoria:** ${test.categoria || 'N/A'}\n`;
  text += `**Resultado:** ${result?.resultado || 'Sin ejecutar'}\n`;
  text += `**Chatbot:** ${chatbotName || 'N/A'}\n\n`;

  text += `### Mensajes enviados:\n`;
  (test.mensajes || []).forEach((m, i) => { text += `${i + 1}. "${m}"\n`; });

  if (result?.respuestas?.length > 0) {
    text += `\n### Respuestas del bot:\n`;
    result.respuestas.forEach((r) => {
      text += `**Pregunta:** "${r.mensaje_enviado}"\n`;
      text += `**Respuesta:** "${r.respuesta_bot}"\n\n`;
    });
  }

  if (result?.twilio_interceptados?.length > 0) {
    text += `### Mensajes DIRECT-SEND (Twilio):\n`;
    result.twilio_interceptados.forEach((m) => {
      if (m.body) text += `- "${m.body}"\n`;
    });
    text += '\n';
  }

  text += `### Criterios de evaluacion:\n`;
  text += `**Espera:** ${test.espera}\n`;
  if (test.no_debe_contener?.length > 0) {
    text += `**No debe contener:** ${test.no_debe_contener.map(t => `"${t}"`).join(', ')}\n`;
  }
  if (test.debe_contener_alguno?.length > 0) {
    text += `**Debe contener alguno:** ${test.debe_contener_alguno.map(t => `"${t}"`).join(', ')}\n`;
  }

  if (result?.razon) {
    text += `\n### Razon del resultado:\n${result.razon}\n`;
  }

  return text;
};

const AdminTests = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [currentTab, setCurrentTab] = useState(0);

  // Data
  const [categorias, setCategorias] = useState([]);
  const [totalTests, setTotalTests] = useState(0);
  const [historial, setHistorial] = useState([]);
  const [chatbots, setChatbots] = useState([]);
  const [selectedChatbot, setSelectedChatbot] = useState(null);

  // UI state
  const [expandedCats, setExpandedCats] = useState({});
  const [ejecutando, setEjecutando] = useState(false);
  const [ejecutandoProgreso, setEjecutandoProgreso] = useState(null);
  const [ultimaEjecucion, setUltimaEjecucion] = useState(null);
  const [resultadosPorTest, setResultadosPorTest] = useState({});
  const [copiedTestId, setCopiedTestId] = useState(null);
  const [filterResultado, setFilterResultado] = useState('all');
  const abortControllerRef = React.useRef(null);

  // Patient selection
  const [tipoPaciente, setTipoPaciente] = useState('ficticio');
  const [pacientes, setPacientes] = useState([]);
  const [selectedPaciente, setSelectedPaciente] = useState(null);
  const [loadingPacientes, setLoadingPacientes] = useState(false);

  // Dialogs
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [showDetalleDialog, setShowDetalleDialog] = useState(false);
  const [showHistorialDetalle, setShowHistorialDetalle] = useState(null);
  const [editingTest, setEditingTest] = useState(null);
  const [detalleTest, setDetalleTest] = useState(null);

  // Form
  const [formData, setFormData] = useState({
    test_id: '', categoria: '', categoria_nombre: '', nombre: '',
    mensajes: [''], espera: '', no_debe_contener: [''], debe_contener_alguno: [''],
    pausa: 3, enabled: true, orden: 0,
  });
  const [nuevoMensaje, setNuevoMensaje] = useState('');
  const [addMsgTarget, setAddMsgTarget] = useState(null); // { test_id, mensajes, nombre }
  const [sugerenciaLoading, setSugerenciaLoading] = useState(false);
  const [sugerenciaRazon, setSugerenciaRazon] = useState('');

  const userId = localStorage.getItem('user_id');

  useEffect(() => {
    loadData();
    loadChatbots();
  }, []);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/admin/tests?user_id=${userId}&enabled_only=false`);
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || 'Error cargando tests');
      }
      const data = await res.json();
      setCategorias(data.categorias || []);
      setTotalTests(data.total || 0);
      setExpandedCats({});
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const loadChatbots = async () => {
    try {
      const res = await fetch(`${API_BASE}/smart-flows/chatbots?user_id=${userId}`);
      if (res.ok) {
        const data = await res.json();
        setChatbots(Array.isArray(data) ? data : []);
        const cb63 = (Array.isArray(data) ? data : []).find(c => c.id === 63);
        if (cb63) setSelectedChatbot(cb63);
      }
    } catch (err) {
      console.error('Error loading chatbots:', err);
    }
  };

  const loadHistorial = async () => {
    try {
      const url = selectedChatbot
        ? `${API_BASE}/admin/tests/historial?user_id=${userId}&chatbot_id=${selectedChatbot.id}`
        : `${API_BASE}/admin/tests/historial?user_id=${userId}`;
      const res = await fetch(url);
      if (res.ok) {
        const data = await res.json();
        setHistorial(data.ejecuciones || []);
      }
    } catch (err) {
      console.error('Error loading historial:', err);
    }
  };

  useEffect(() => {
    if (currentTab === 1) loadHistorial();
  }, [currentTab, selectedChatbot]);

  const loadPacientes = async (chatbotId) => {
    if (!chatbotId) return;
    setLoadingPacientes(true);
    try {
      const res = await fetch(`${API_BASE}/admin/tests/pacientes?chatbot_id=${chatbotId}&user_id=${userId}`);
      if (res.ok) {
        const data = await res.json();
        setPacientes(data.pacientes || []);
      }
    } catch (err) {
      console.error('Error loading pacientes:', err);
    } finally {
      setLoadingPacientes(false);
    }
  };

  useEffect(() => {
    if (selectedChatbot) {
      loadPacientes(selectedChatbot.id);
    } else {
      setPacientes([]);
      setSelectedPaciente(null);
    }
  }, [selectedChatbot]);

  const handleSeed = async () => {
    try {
      const res = await fetch(`${API_BASE}/admin/tests/seed?user_id=${userId}`, { method: 'POST' });
      if (!res.ok) throw new Error('Error importando tests');
      const data = await res.json();
      setSnackbar({ open: true, message: data.message, severity: 'success' });
      loadData();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleEjecutar = async (testIds = null, catKeys = null) => {
    if (!selectedChatbot) {
      setSnackbar({ open: true, message: 'Selecciona un chatbot primero', severity: 'warning' });
      return;
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setEjecutando(true);
    setEjecutandoProgreso({ mensaje: 'Iniciando ejecucion...', porcentaje: 0 });

    try {
      const body = { chatbot_id: selectedChatbot.id };
      if (testIds) body.test_ids = testIds;
      if (catKeys) body.categorias = catKeys;
      body.tipo_paciente = tipoPaciente;
      if (tipoPaciente === 'registrado' && selectedPaciente) {
        body.cliente_id = selectedPaciente.id;
      }

      const res = await fetch(`${API_BASE}/admin/tests/ejecutar?user_id=${userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller.signal,
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || 'Error ejecutando tests');
      }

      const data = await res.json();
      setUltimaEjecucion(data);

      const resMap = (testIds || catKeys) ? { ...resultadosPorTest } : {};
      (data.resultados || []).forEach(r => { resMap[r.test_id] = r; });
      setResultadosPorTest(resMap);

      if (testIds || catKeys) {
        setFilterResultado('executed');
      }

      const msg = `${data.passed}/${data.total} PASS | ${data.failed} FAIL | ${data.warned} WARN | ${data.duracion_segundos}s`;
      setSnackbar({ open: true, message: msg, severity: data.failed > 0 ? 'warning' : 'success' });
    } catch (err) {
      if (err.name === 'AbortError') {
        setSnackbar({ open: true, message: 'Ejecucion detenida por el usuario', severity: 'info' });
      } else {
        setSnackbar({ open: true, message: err.message, severity: 'error' });
      }
    } finally {
      abortControllerRef.current = null;
      setEjecutando(false);
      setEjecutandoProgreso(null);
    }
  };

  const handleDetener = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };

  const handleCreateOrUpdate = async () => {
    try {
      const payload = {
        ...formData,
        mensajes: formData.mensajes.filter(m => m.trim()),
        no_debe_contener: formData.no_debe_contener.filter(m => m.trim()),
        debe_contener_alguno: formData.debe_contener_alguno.filter(m => m.trim()),
      };

      if (editingTest) {
        const { test_id, categoria, categoria_nombre, ...updatePayload } = payload;
        const res = await fetch(`${API_BASE}/admin/tests/${editingTest}?user_id=${userId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatePayload),
        });
        if (!res.ok) throw new Error('Error actualizando test');
        setSnackbar({ open: true, message: 'Test actualizado', severity: 'success' });
      } else {
        const res = await fetch(`${API_BASE}/admin/tests?user_id=${userId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.detail || 'Error creando test');
        }
        setSnackbar({ open: true, message: 'Test creado', severity: 'success' });
      }
      setShowCreateDialog(false);
      setEditingTest(null);
      loadData();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleDelete = async (testId) => {
    if (!window.confirm(`Eliminar test ${testId}?`)) return;
    try {
      const res = await fetch(`${API_BASE}/admin/tests/${testId}?user_id=${userId}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Error eliminando');
      setSnackbar({ open: true, message: 'Test eliminado', severity: 'success' });
      loadData();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const openEditDialog = (test) => {
    setEditingTest(test.test_id);
    setFormData({
      test_id: test.test_id,
      categoria: test.categoria || '',
      categoria_nombre: test.categoria_nombre || '',
      nombre: test.nombre,
      mensajes: test.mensajes?.length ? test.mensajes : [''],
      espera: test.espera,
      no_debe_contener: test.no_debe_contener?.length ? test.no_debe_contener : [''],
      debe_contener_alguno: test.debe_contener_alguno?.length ? test.debe_contener_alguno : [''],
      pausa: test.pausa || 3,
      enabled: test.enabled !== false,
      orden: test.orden || 0,
    });
    setShowCreateDialog(true);
  };

  const openCreateDialog = () => {
    setEditingTest(null);
    setSugerenciaRazon('');
    setFormData({
      test_id: '', categoria: '', categoria_nombre: '', nombre: '',
      mensajes: [''], espera: '', no_debe_contener: [''], debe_contener_alguno: [''],
      pausa: 3, enabled: true, orden: 0,
    });
    setShowCreateDialog(true);
  };

  const openCreateInCategory = (cat) => {
    setEditingTest(null);
    setSugerenciaRazon('');
    // Auto-generate next test_id
    const existingIds = (cat.tests || []).map(t => t.test_id);
    let prefix = '';
    let maxNum = 0;
    existingIds.forEach(tid => {
      const parts = tid.split('-');
      if (parts.length === 2) {
        prefix = parts[0];
        const num = parseInt(parts[1]);
        if (!isNaN(num) && num > maxNum) maxNum = num;
      }
    });
    const nextId = prefix ? `${prefix}-${String(maxNum + 1).padStart(2, '0')}` : '';
    const nextOrden = Math.max(...(cat.tests || []).map(t => t.orden || 0), 0) + 1;

    setFormData({
      test_id: nextId,
      categoria: cat.categoria,
      categoria_nombre: cat.categoria_nombre,
      nombre: '',
      mensajes: [''], espera: '', no_debe_contener: [''], debe_contener_alguno: [''],
      pausa: 3, enabled: true, orden: nextOrden,
    });
    setShowCreateDialog(true);
  };

  const handleSugerirIA = async (cat) => {
    setSugerenciaLoading(true);
    setSugerenciaRazon('');
    try {
      // Find the category data
      const catData = categorias.find(c => c.categoria === (cat?.categoria || formData.categoria));
      if (!catData) throw new Error('Categoría no encontrada');

      const res = await fetch(`${API_BASE}/admin/tests/sugerir?user_id=${userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          categoria: catData.categoria,
          categoria_nombre: catData.categoria_nombre,
          tests_existentes: (catData.tests || []).map(t => ({
            test_id: t.test_id,
            nombre: t.nombre,
            mensajes: t.mensajes,
            espera: t.espera,
          })),
        }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || 'Error obteniendo sugerencia');
      }
      const data = await res.json();
      setFormData(prev => ({
        ...prev,
        test_id: data.test_id || prev.test_id,
        nombre: data.nombre || prev.nombre,
        mensajes: data.mensajes?.length ? data.mensajes : prev.mensajes,
        espera: data.espera || prev.espera,
        no_debe_contener: data.no_debe_contener?.length ? data.no_debe_contener : prev.no_debe_contener,
      }));
      setSugerenciaRazon(data.razonamiento || '');
      setSnackbar({ open: true, message: 'Sugerencia generada por IA', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    } finally {
      setSugerenciaLoading(false);
    }
  };

  const handleAddMessage = async (testId, currentMensajes) => {
    if (!nuevoMensaje.trim()) return;
    try {
      const updatedMensajes = [...(currentMensajes || []), nuevoMensaje.trim()];
      const res = await fetch(`${API_BASE}/admin/tests/${testId}?user_id=${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mensajes: updatedMensajes }),
      });
      if (!res.ok) throw new Error('Error agregando mensaje');
      setNuevoMensaje('');
      setSnackbar({ open: true, message: 'Mensaje agregado', severity: 'success' });
      // Update detalleTest in-place so UI refreshes immediately
      setDetalleTest(prev => prev ? { ...prev, mensajes: updatedMensajes } : prev);
      loadData();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleRemoveMessage = async (testId, currentMensajes, index) => {
    if (currentMensajes.length <= 1) return; // Keep at least 1 message
    try {
      const updatedMensajes = currentMensajes.filter((_, i) => i !== index);
      const res = await fetch(`${API_BASE}/admin/tests/${testId}?user_id=${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mensajes: updatedMensajes }),
      });
      if (!res.ok) throw new Error('Error eliminando mensaje');
      setSnackbar({ open: true, message: 'Mensaje eliminado', severity: 'success' });
      setDetalleTest(prev => prev ? { ...prev, mensajes: updatedMensajes } : prev);
      loadData();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const loadHistorialDetalle = async (ejecucionId) => {
    try {
      const res = await fetch(`${API_BASE}/admin/tests/historial/${ejecucionId}?user_id=${userId}`);
      if (res.ok) {
        const data = await res.json();
        setShowHistorialDetalle(data);
      }
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const handleCopyTest = (test, result) => {
    const text = formatTestForClipboard(test, result, selectedChatbot?.name);
    navigator.clipboard.writeText(text).then(() => {
      setCopiedTestId(test.test_id);
      setTimeout(() => setCopiedTestId(null), 2000);
      setSnackbar({ open: true, message: `Resultado de ${test.test_id} copiado`, severity: 'success' });
    });
  };

  const handleCopyFailed = () => {
    const failed = Object.entries(resultadosPorTest)
      .filter(([, r]) => r.resultado === 'FAIL' || r.resultado === 'WARN')
      .map(([testId, r]) => {
        const test = categorias.flatMap(c => c.tests).find(t => t.test_id === testId);
        return test ? formatTestForClipboard(test, r, selectedChatbot?.name) : '';
      })
      .filter(Boolean);

    if (failed.length === 0) {
      setSnackbar({ open: true, message: 'No hay tests fallidos para copiar', severity: 'info' });
      return;
    }

    const header = `# Resultados de Tests Fallidos\n**Chatbot:** ${selectedChatbot?.name}\n**Fecha:** ${new Date().toLocaleString('es-MX')}\n**Paciente:** ${tipoPaciente === 'registrado' && selectedPaciente ? selectedPaciente.nombre : 'Ficticio'}\n\n---\n\n`;
    const text = header + failed.join('\n---\n\n');
    navigator.clipboard.writeText(text).then(() => {
      setSnackbar({ open: true, message: `${failed.length} tests fallidos copiados`, severity: 'success' });
    });
  };

  const handleExpandAll = () => {
    const all = {};
    categorias.forEach(c => { all[c.categoria] = true; });
    setExpandedCats(all);
  };

  const handleCollapseAll = () => {
    setExpandedCats({});
  };

  const allExpanded = categorias.length > 0 && categorias.every(c => expandedCats[c.categoria] === true);

  const handleLimpiarResultados = () => {
    setResultadosPorTest({});
    setUltimaEjecucion(null);
    setFilterResultado('all');
    setSnackbar({ open: true, message: 'Resultados limpiados', severity: 'info' });
  };

  const getFilteredTests = (tests) => {
    if (filterResultado === 'all') return tests;
    return tests.filter(t => {
      const r = resultadosPorTest[t.test_id];
      if (filterResultado === 'FAIL') return r?.resultado === 'FAIL';
      if (filterResultado === 'WARN') return r?.resultado === 'WARN';
      if (filterResultado === 'PASS') return r?.resultado === 'PASS';
      if (filterResultado === 'executed') return !!r;
      return true;
    });
  };

  const resultCounts = {
    total: Object.keys(resultadosPorTest).length,
    pass: Object.values(resultadosPorTest).filter(r => r.resultado === 'PASS').length,
    fail: Object.values(resultadosPorTest).filter(r => r.resultado === 'FAIL').length,
    warn: Object.values(resultadosPorTest).filter(r => r.resultado === 'WARN').length,
  };

  // ── KPI data ──
  const kpiCards = [
    {
      label: resultCounts.total > 0 ? `${resultCounts.total} ejecutados` : 'tests definidos',
      value: resultCounts.total > 0 ? resultCounts.total : totalTests,
      icon: <BugReportIcon />,
      gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
      shadow: 'rgba(99, 102, 241, 0.4)',
      filterKey: null,
    },
    {
      label: resultCounts.total > 0 ? `${resultCounts.total > 0 ? Math.round((resultCounts.pass / resultCounts.total) * 100) : 0}% aprobados` : 'sin ejecutar',
      value: resultCounts.total > 0 ? resultCounts.pass : '—',
      icon: <CheckCircleIcon />,
      gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      shadow: 'rgba(16, 185, 129, 0.4)',
      filterKey: 'PASS',
    },
    {
      label: resultCounts.total > 0 ? `${resultCounts.total > 0 ? Math.round((resultCounts.fail / resultCounts.total) * 100) : 0}% fallidos` : 'sin ejecutar',
      value: resultCounts.total > 0 ? resultCounts.fail : '—',
      icon: <CancelIcon />,
      gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
      shadow: 'rgba(239, 68, 68, 0.4)',
      filterKey: 'FAIL',
    },
    {
      label: resultCounts.total > 0 ? `${resultCounts.total > 0 ? Math.round((resultCounts.warn / resultCounts.total) * 100) : 0}% advertencias` : 'sin ejecutar',
      value: resultCounts.total > 0 ? resultCounts.warn : '—',
      icon: <WarningAmberIcon />,
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      shadow: 'rgba(245, 158, 11, 0.4)',
      filterKey: 'WARN',
    },
  ];

  // ── LOADING STATE ──
  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: '#f1f5f9', gap: 2 }}>
        <CircularProgress sx={{ color: '#6366f1' }} />
        <Typography sx={{ color: '#64748b', fontSize: 14 }}>Cargando test suite...</Typography>
      </Box>
    );
  }

  // ── ERROR STATE ──
  if (error) {
    return (
      <Box sx={{ minHeight: '100vh', p: 4, bgcolor: '#f1f5f9' }}>
        <Alert severity="error" sx={{ maxWidth: 500, mx: 'auto' }}>{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f1f5f9', p: { xs: 2, md: 3 } }}>
      <Box sx={{ maxWidth: 1400, mx: 'auto' }}>

        {/* ══════════════════════════════════════════════════════════════ */}
        {/* HEADER */}
        {/* ══════════════════════════════════════════════════════════════ */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
          <Box>
            <Typography variant="h5" sx={{ color: '#1e293b', fontWeight: 800, letterSpacing: -0.5 }}>Test Suite</Typography>
            <Typography sx={{ color: '#64748b', fontSize: 12, mt: 0.25 }}>
              {totalTests} tests · {categorias.length} categorias
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Autocomplete
              value={selectedChatbot}
              onChange={(e, v) => setSelectedChatbot(v)}
              options={chatbots}
              getOptionLabel={(opt) => `${opt.name} (ID: ${opt.id})`}
              size="small"
              sx={{
                width: 260,
                '& .MuiOutlinedInput-root': {
                  bgcolor: '#fff', color: '#1e293b', borderRadius: 2, fontSize: 13,
                  '& fieldset': { borderColor: '#e2e8f0' },
                  '&:hover fieldset': { borderColor: '#94a3b8' },
                },
                '& .MuiInputLabel-root': { color: '#64748b', fontSize: 13 },
                '& .MuiAutocomplete-clearIndicator': { color: '#94a3b8' },
                '& .MuiAutocomplete-popupIndicator': { color: '#94a3b8' },
              }}
              renderInput={(params) => <TextField {...params} label="Chatbot" placeholder="Seleccionar..." />}
            />
            <Tooltip title="Refrescar">
              <IconButton onClick={loadData} sx={{ color: '#64748b', '&:hover': { bgcolor: 'rgba(30,58,95,0.05)', color: '#1e3a5f' } }}>
                <RefreshIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* ══════════════════════════════════════════════════════════════ */}
        {/* KPI CARDS */}
        {/* ══════════════════════════════════════════════════════════════ */}
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(4, 1fr)' },
          gap: 2, mb: 3,
        }}>
          {kpiCards.map((kpi, i) => (
            <Box
              key={i}
              onClick={() => kpi.filterKey && setFilterResultado(prev => prev === kpi.filterKey ? 'all' : kpi.filterKey)}
              sx={{
                p: 2, borderRadius: 3, position: 'relative', overflow: 'hidden',
                background: '#fff',
                border: filterResultado === kpi.filterKey
                  ? `2px solid ${kpi.shadow.replace('0.4', '0.8')}`
                  : '1px solid #e2e8f0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.04)',
                cursor: kpi.filterKey ? 'pointer' : 'default',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': kpi.filterKey ? {
                  transform: 'translateY(-2px)',
                  boxShadow: `0 8px 24px ${kpi.shadow}`,
                } : {},
                '&::before': {
                  content: '""', position: 'absolute',
                  top: 0, left: 0, right: 0, height: 3,
                  background: kpi.gradient,
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{
                  width: 36, height: 36, borderRadius: 2, display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  background: kpi.gradient,
                  boxShadow: `0 4px 12px ${kpi.shadow}`,
                  '& svg': { fontSize: 18, color: '#fff' },
                }}>
                  {kpi.icon}
                </Box>
                <Box>
                  <Typography sx={{
                    fontSize: 24, fontWeight: 800, lineHeight: 1,
                    background: kpi.gradient,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}>
                    {kpi.value}
                  </Typography>
                  <Typography sx={{
                    fontSize: 10, fontWeight: 600, color: '#94a3b8',
                    textTransform: 'uppercase', letterSpacing: 0.5, mt: 0.25,
                  }}>
                    {kpi.label}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>

        {/* ══════════════════════════════════════════════════════════════ */}
        {/* TABS */}
        {/* ══════════════════════════════════════════════════════════════ */}
        <Tabs
          value={currentTab}
          onChange={(e, v) => setCurrentTab(v)}
          sx={{
            mb: 2,
            '& .MuiTab-root': { color: '#64748b', fontSize: 13, fontWeight: 600, textTransform: 'none', minHeight: 40, '&.Mui-selected': { color: '#1e3a5f' } },
            '& .MuiTabs-indicator': { bgcolor: '#1e3a5f', height: 3, borderRadius: 2 },
          }}
        >
          <Tab label="Tests" icon={<BugReportIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
          <Tab label="Historial" icon={<HistoryIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
        </Tabs>

        {/* ══════════════════════════════════════════════════════════════ */}
        {/* TAB 0: TESTS */}
        {/* ══════════════════════════════════════════════════════════════ */}
        {currentTab === 0 && (
          <>
            {/* ── TOOLBAR UNIFICADA ── */}
            <Box sx={{
              mb: 3, borderRadius: 3, overflow: 'hidden',
              bgcolor: '#fff',
              border: '1px solid #e2e8f0',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            }}>
              {/* Fila 1: Ejecutar + Paciente + Acciones */}
              <Box sx={{
                display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5,
                flexWrap: 'wrap', borderBottom: '1px solid #f1f5f9',
              }}>
                <Button
                  variant="contained"
                  startIcon={ejecutando ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : <PlayArrowIcon />}
                  disabled={ejecutando || !selectedChatbot}
                  onClick={() => handleEjecutar()}
                  size="small"
                  sx={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    fontSize: 12, textTransform: 'none', borderRadius: 2, fontWeight: 700,
                    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)',
                    '&:hover': { background: 'linear-gradient(135deg, #059669 0%, #047857 100%)' },
                    '&:disabled': { opacity: 0.5, color: '#fff' },
                  }}
                >
                  {ejecutando ? 'Ejecutando...' : 'Ejecutar Todo'}
                </Button>

                <Button
                  variant="contained"
                  startIcon={<StopIcon />}
                  onClick={handleDetener}
                  disabled={!ejecutando}
                  size="small"
                  sx={{
                    background: ejecutando ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' : 'rgba(100,100,100,0.2)',
                    fontSize: 12, textTransform: 'none', borderRadius: 2, fontWeight: 700,
                    boxShadow: ejecutando ? '0 4px 12px rgba(239, 68, 68, 0.4)' : 'none',
                    ...(ejecutando && {
                      animation: 'pulse 1.5s infinite',
                      '@keyframes pulse': {
                        '0%, 100%': { boxShadow: '0 4px 12px rgba(239, 68, 68, 0.4)' },
                        '50%': { boxShadow: '0 4px 20px rgba(239, 68, 68, 0.7)' },
                      },
                    }),
                    '&:hover': { background: ejecutando ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)' : undefined },
                    '&:disabled': { opacity: 0.3, color: '#fff' },
                  }}
                >
                  Detener
                </Button>

                {/* Separator */}
                <Box sx={{ width: 1, height: 24, bgcolor: '#e2e8f0', mx: 0.5 }} />

                {/* Patient type toggle */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PersonOutlineIcon sx={{ color: '#94a3b8', fontSize: 18 }} />
                  <ToggleButtonGroup
                    value={tipoPaciente}
                    exclusive
                    onChange={(e, val) => { if (val) { setTipoPaciente(val); if (val === 'ficticio') setSelectedPaciente(null); } }}
                    size="small"
                    sx={{
                      '& .MuiToggleButton-root': {
                        color: '#64748b', borderColor: '#e2e8f0',
                        fontSize: 11, fontWeight: 600, textTransform: 'none', py: 0.4, px: 1.5,
                        '&.Mui-selected': { bgcolor: '#1e3a5f', color: '#fff', borderColor: '#1e3a5f' },
                        '&:hover': { bgcolor: 'rgba(30,58,95,0.05)' },
                      },
                    }}
                  >
                    <ToggleButton value="ficticio">Ficticio</ToggleButton>
                    <ToggleButton value="registrado">Registrado</ToggleButton>
                  </ToggleButtonGroup>

                  {tipoPaciente === 'registrado' && (
                    <Autocomplete
                      value={selectedPaciente}
                      onChange={(e, v) => setSelectedPaciente(v)}
                      options={pacientes}
                      loading={loadingPacientes}
                      getOptionLabel={(opt) => `${opt.nombre} (${opt.numero})`}
                      isOptionEqualToValue={(opt, val) => opt.id === val.id}
                      size="small"
                      sx={{
                        width: 220,
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#fff', color: '#1e293b', borderRadius: 2, fontSize: 12,
                          '& fieldset': { borderColor: '#e2e8f0' },
                          '&:hover fieldset': { borderColor: '#94a3b8' },
                        },
                        '& .MuiInputLabel-root': { color: '#64748b', fontSize: 12 },
                        '& .MuiAutocomplete-clearIndicator': { color: '#94a3b8' },
                        '& .MuiAutocomplete-popupIndicator': { color: '#94a3b8' },
                      }}
                      renderInput={(params) => <TextField {...params} label="Paciente" placeholder="Buscar..." />}
                      noOptionsText="Sin pacientes"
                    />
                  )}
                  {tipoPaciente === 'registrado' && selectedPaciente && (
                    <Chip
                      icon={<PersonIcon sx={{ fontSize: 14 }} />}
                      label={selectedPaciente.nombre}
                      size="small"
                      sx={{ bgcolor: 'rgba(16,185,129,0.2)', color: '#6ee7b7', fontWeight: 600, fontSize: 11, '& .MuiChip-icon': { color: '#10b981' } }}
                    />
                  )}
                </Box>

                <Box sx={{ flex: 1 }} />

                {/* Secondary actions */}
                <Button
                  startIcon={<DownloadIcon />}
                  onClick={handleSeed}
                  size="small"
                  sx={{ color: '#64748b', fontSize: 11, textTransform: 'none', fontWeight: 600, '&:hover': { bgcolor: 'rgba(30,58,95,0.05)', color: '#1e3a5f' } }}
                >
                  Seed
                </Button>
                <Button
                  startIcon={<AddIcon />}
                  onClick={openCreateDialog}
                  size="small"
                  sx={{ color: '#64748b', fontSize: 11, textTransform: 'none', fontWeight: 600, '&:hover': { bgcolor: 'rgba(30,58,95,0.05)', color: '#1e3a5f' } }}
                >
                  Nuevo
                </Button>
              </Box>

              {/* Fila 2: Filtros + Acciones de resultado */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, px: 2, py: 1 }}>
                {[
                  { key: 'all', label: `Todos (${totalTests})`, color: '#94a3b8' },
                  { key: 'executed', label: `Ejecutados (${resultCounts.total})`, color: '#3b82f6' },
                  { key: 'PASS', label: `Pass (${resultCounts.pass})`, color: '#10b981' },
                  { key: 'FAIL', label: `Fail (${resultCounts.fail})`, color: '#ef4444' },
                  { key: 'WARN', label: `Warn (${resultCounts.warn})`, color: '#f59e0b' },
                ].map(f => (
                  <Chip
                    key={f.key}
                    label={f.label}
                    size="small"
                    onClick={() => setFilterResultado(f.key)}
                    sx={{
                      cursor: 'pointer', fontWeight: 600, fontSize: 11, height: 26,
                      bgcolor: filterResultado === f.key ? `${f.color}20` : 'transparent',
                      color: filterResultado === f.key ? f.color : '#94a3b8',
                      border: filterResultado === f.key ? `1px solid ${f.color}` : '1px solid transparent',
                      transition: 'all 0.2s ease',
                      '&:hover': { bgcolor: `${f.color}15`, color: f.color },
                    }}
                  />
                ))}

                <Box sx={{ flex: 1 }} />

                {resultCounts.fail > 0 && (
                  <Button
                    startIcon={<ContentCopyIcon sx={{ fontSize: 14 }} />}
                    onClick={handleCopyFailed}
                    size="small"
                    sx={{ color: '#ef4444', fontSize: 10, textTransform: 'none', fontWeight: 600, '&:hover': { bgcolor: 'rgba(239,68,68,0.08)' } }}
                  >
                    Copiar {resultCounts.fail} fallidos
                  </Button>
                )}

                {resultCounts.total > 0 && (
                  <Button
                    startIcon={<DeleteIcon sx={{ fontSize: 14 }} />}
                    onClick={handleLimpiarResultados}
                    size="small"
                    sx={{ color: '#94a3b8', fontSize: 10, textTransform: 'none', fontWeight: 600, '&:hover': { bgcolor: 'rgba(30,58,95,0.05)', color: '#1e3a5f' } }}
                  >
                    Limpiar
                  </Button>
                )}

                <Tooltip title={allExpanded ? 'Colapsar todo' : 'Expandir todo'}>
                  <IconButton
                    onClick={allExpanded ? handleCollapseAll : handleExpandAll}
                    size="small"
                    sx={{ color: '#94a3b8', '&:hover': { bgcolor: 'rgba(30,58,95,0.05)', color: '#1e3a5f' } }}
                  >
                    {allExpanded ? <UnfoldLessIcon sx={{ fontSize: 18 }} /> : <UnfoldMoreIcon sx={{ fontSize: 18 }} />}
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            {/* ── EXECUTION PROGRESS ── */}
            {ejecutando && (
              <Box sx={{
                mb: 2, p: 2, borderRadius: 3,
                background: '#fffbeb',
                border: '1px solid #fde68a',
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={14} sx={{ color: '#fbbf24' }} />
                    <Typography sx={{ color: '#fbbf24', fontSize: 13, fontWeight: 700 }}>
                      Ejecutando tests contra {selectedChatbot?.name}
                      {tipoPaciente === 'registrado' && selectedPaciente ? ` (${selectedPaciente.nombre})` : ''}...
                    </Typography>
                  </Box>
                  <Button
                    startIcon={<StopIcon sx={{ fontSize: 14 }} />}
                    onClick={handleDetener}
                    size="small"
                    sx={{ color: '#fca5a5', fontSize: 11, textTransform: 'none', fontWeight: 600, '&:hover': { bgcolor: 'rgba(239,68,68,0.15)' } }}
                  >
                    Detener
                  </Button>
                </Box>
                <LinearProgress sx={{ borderRadius: 2, height: 4, bgcolor: 'rgba(255,255,255,0.08)', '& .MuiLinearProgress-bar': { bgcolor: '#fbbf24', borderRadius: 2 } }} />
              </Box>
            )}

            {/* ── EMPTY STATE ── */}
            {categorias.length === 0 && (
              <Box sx={{ p: 6, textAlign: 'center', background: '#fff', borderRadius: 4, border: '1px solid #e2e8f0' }}>
                <BugReportIcon sx={{ fontSize: 56, color: '#cbd5e1', mb: 1.5 }} />
                <Typography sx={{ color: '#1e293b', fontSize: 16, fontWeight: 600 }}>No hay tests definidos</Typography>
                <Typography sx={{ color: '#64748b', fontSize: 13, mb: 2 }}>Importa los tests iniciales con el boton "Seed"</Typography>
                <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleSeed} sx={{ bgcolor: '#1e3a5f', textTransform: 'none', borderRadius: 2, fontWeight: 600 }}>
                  Importar Seed
                </Button>
              </Box>
            )}

            {/* ══════════════════════════════════════════════════════════ */}
            {/* CATEGORIES + TEST CARDS */}
            {/* ══════════════════════════════════════════════════════════ */}
            {categorias.map((cat) => {
              const color = getCatColor(cat.categoria);
              const expanded = expandedCats[cat.categoria] === true;
              const filteredTests = getFilteredTests(cat.tests);
              const catResults = cat.tests.map(t => resultadosPorTest[t.test_id]).filter(Boolean);
              const catPass = catResults.filter(r => r.resultado === 'PASS').length;
              const catFail = catResults.filter(r => r.resultado === 'FAIL').length;
              const catWarn = catResults.filter(r => r.resultado === 'WARN').length;

              if (filterResultado !== 'all' && filteredTests.length === 0) return null;

              return (
                <Box key={cat.categoria} sx={{ mb: 2 }}>
                  {/* Category header */}
                  <Box
                    onClick={() => setExpandedCats(prev => ({ ...prev, [cat.categoria]: !expanded }))}
                    sx={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      px: 2, py: 1.25, borderRadius: expanded ? '12px 12px 0 0' : 3,
                      background: color.gradient, cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      boxShadow: `0 4px 12px ${color.shadow}`,
                      '&:hover': { filter: 'brightness(1.1)' },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 13 }}>
                        {cat.categoria_nombre}
                      </Typography>
                      <Chip
                        label={filterResultado !== 'all' ? `${filteredTests.length}/${cat.tests.length}` : cat.tests.length}
                        size="small"
                        sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontWeight: 700, fontSize: 11, height: 22, minWidth: 28 }}
                      />
                      {catResults.length > 0 && (
                        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                          {catPass > 0 && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}><CheckCircleIcon sx={{ fontSize: 12, color: 'rgba(255,255,255,0.9)' }} /><Typography sx={{ color: 'rgba(255,255,255,0.9)', fontSize: 11, fontWeight: 700 }}>{catPass}</Typography></Box>}
                          {catFail > 0 && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}><CancelIcon sx={{ fontSize: 12, color: '#fecaca' }} /><Typography sx={{ color: '#fecaca', fontSize: 11, fontWeight: 700 }}>{catFail}</Typography></Box>}
                          {catWarn > 0 && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}><WarningAmberIcon sx={{ fontSize: 12, color: '#fde68a' }} /><Typography sx={{ color: '#fde68a', fontSize: 11, fontWeight: 700 }}>{catWarn}</Typography></Box>}
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Tooltip title="Agregar test a esta categoria">
                        <IconButton
                          size="small"
                          onClick={(e) => { e.stopPropagation(); openCreateInCategory(cat); }}
                          sx={{ color: 'rgba(255,255,255,0.8)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }, p: 0.5 }}
                        >
                          <AddIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ejecutar categoria">
                        <IconButton
                          size="small"
                          onClick={(e) => { e.stopPropagation(); handleEjecutar(null, [cat.categoria]); }}
                          disabled={ejecutando || !selectedChatbot}
                          sx={{ color: 'rgba(255,255,255,0.8)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }, p: 0.5 }}
                        >
                          <PlayArrowIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      {expanded ? <ExpandLessIcon sx={{ color: 'rgba(255,255,255,0.8)', fontSize: 20 }} /> : <ExpandMoreIcon sx={{ color: 'rgba(255,255,255,0.8)', fontSize: 20 }} />}
                    </Box>
                  </Box>

                  {/* Tests grid */}
                  <Collapse in={expanded}>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' },
                      gap: 1.5, p: 2,
                      background: '#fff',
                      borderRadius: '0 0 12px 12px',
                      border: '1px solid #e2e8f0', borderTop: 'none',
                    }}>
                      {filteredTests.map((test) => {
                        const testResult = resultadosPorTest[test.test_id];
                        const isCopied = copiedTestId === test.test_id;
                        const resultColor = testResult
                          ? testResult.resultado === 'PASS' ? '#10b981' : testResult.resultado === 'FAIL' ? '#ef4444' : '#f59e0b'
                          : '#475569';

                        return (
                          <Box
                            key={test.test_id}
                            onClick={() => { setDetalleTest({ ...test, resultado: testResult }); setNuevoMensaje(''); setShowDetalleDialog(true); }}
                            sx={{
                              borderRadius: 3, position: 'relative', overflow: 'hidden',
                              background: '#f8fafc',
                              borderLeft: `3px solid ${resultColor}`,
                              cursor: 'pointer',
                              transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                              '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: `0 8px 24px ${testResult ? (resultColor + '40') : 'rgba(0,0,0,0.12)'}`,
                                background: '#fff',
                              },
                            }}
                          >
                            {/* Card header */}
                            <Box sx={{ px: 1.5, pt: 1.5, pb: 0.75 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                  <Typography sx={{ fontSize: 11, fontWeight: 800, color: color.bg, fontFamily: 'monospace' }}>
                                    {test.test_id}
                                  </Typography>
                                  {(test.mensajes?.length || 0) > 1 && (
                                    <Chip label={`${test.mensajes.length} msgs`} size="small" sx={{ height: 16, fontSize: 9, fontWeight: 600, bgcolor: '#eff6ff', color: '#3b82f6', '& .MuiChip-label': { px: 0.5 } }} />
                                  )}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                  {testResult && (
                                    <Typography sx={{ fontSize: 9, color: '#94a3b8' }}>{testResult.duracion_ms}ms</Typography>
                                  )}
                                  <ResultChip resultado={testResult?.resultado} />
                                </Box>
                              </Box>
                              <Typography sx={{
                                fontSize: 12, fontWeight: 600, color: '#1e293b', lineHeight: 1.3,
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              }}>
                                {test.nombre}
                              </Typography>
                              <Typography sx={{
                                fontSize: 11, color: '#64748b', mt: 0.5,
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                fontStyle: 'italic',
                              }}>
                                "{test.mensajes?.[0] || ''}"
                              </Typography>
                              {/* Failure reason */}
                              {testResult?.razon && testResult.resultado !== 'PASS' && (
                                <Typography sx={{
                                  fontSize: 10, mt: 0.5, px: 0.75, py: 0.25, borderRadius: 1,
                                  bgcolor: testResult.resultado === 'FAIL' ? '#fef2f2' : '#fffbeb',
                                  color: testResult.resultado === 'FAIL' ? '#dc2626' : '#d97706',
                                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                }}>
                                  {testResult.razon}
                                </Typography>
                              )}
                            </Box>

                            {/* Card actions */}
                            <Box sx={{
                              display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
                              px: 1, py: 0.5, borderTop: '1px solid #f1f5f9',
                              gap: 0.25,
                            }}>
                              <Tooltip title="Ejecutar">
                                <IconButton
                                  size="small"
                                  onClick={(e) => { e.stopPropagation(); handleEjecutar([test.test_id]); }}
                                  disabled={ejecutando || !selectedChatbot}
                                  sx={{ color: '#10b981', p: 0.5, '&:hover': { bgcolor: '#f0fdf4' } }}
                                >
                                  <PlayArrowIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={isCopied ? 'Copiado!' : 'Copiar'}>
                                <IconButton
                                  size="small"
                                  onClick={(e) => { e.stopPropagation(); handleCopyTest(test, testResult); }}
                                  sx={{ color: isCopied ? '#10b981' : '#94a3b8', p: 0.5, '&:hover': { bgcolor: '#f1f5f9' } }}
                                >
                                  {isCopied ? <CheckIcon sx={{ fontSize: 14 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />}
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Agregar mensaje">
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); setAddMsgTarget({ test_id: test.test_id, mensajes: test.mensajes || [], nombre: test.nombre }); setNuevoMensaje(''); }} sx={{ color: '#3b82f6', p: 0.5, '&:hover': { bgcolor: '#eff6ff', color: '#1e3a5f' } }}>
                                  <AddCommentIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Editar">
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); openEditDialog(test); }} sx={{ color: '#94a3b8', p: 0.5, '&:hover': { bgcolor: '#f1f5f9', color: '#1e3a5f' } }}>
                                  <EditIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Eliminar">
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDelete(test.test_id); }} sx={{ color: '#94a3b8', p: 0.5, '&:hover': { bgcolor: '#fef2f2', color: '#ef4444' } }}>
                                  <DeleteIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Collapse>
                </Box>
              );
            })}
          </>
        )}

        {/* ══════════════════════════════════════════════════════════════ */}
        {/* TAB 1: HISTORIAL */}
        {/* ══════════════════════════════════════════════════════════════ */}
        {currentTab === 1 && (
          <>
            {historial.length === 0 ? (
              <Box sx={{ p: 6, textAlign: 'center', background: '#fff', borderRadius: 4, border: '1px solid #e2e8f0' }}>
                <HistoryIcon sx={{ fontSize: 56, color: '#cbd5e1', mb: 1.5 }} />
                <Typography sx={{ color: '#1e293b', fontSize: 16, fontWeight: 600 }}>Sin historial de ejecuciones</Typography>
                <Typography sx={{ color: '#64748b', fontSize: 13 }}>Ejecuta tests para ver resultados aqui</Typography>
              </Box>
            ) : (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {historial.map((ej) => (
                  <Box
                    key={ej.id}
                    onClick={() => loadHistorialDetalle(ej.id)}
                    sx={{
                      p: 2, borderRadius: 3, cursor: 'pointer',
                      background: '#fff',
                      border: '1px solid #e2e8f0',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      transition: 'all 0.2s ease',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box sx={{
                          width: 40, height: 40, borderRadius: 2,
                          background: ej.failed > 0 ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
                          boxShadow: `0 4px 12px ${ej.failed > 0 ? 'rgba(239,68,68,0.4)' : 'rgba(16,185,129,0.4)'}`,
                        }}>
                          {ej.failed > 0 ? <CancelIcon sx={{ fontSize: 20 }} /> : <CheckCircleIcon sx={{ fontSize: 20 }} />}
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#1e293b' }}>
                            {ej.chatbot_nombre}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <AccessTimeIcon sx={{ fontSize: 12, color: '#94a3b8' }} />
                            <Typography sx={{ fontSize: 11, color: '#64748b' }}>
                              {ej.fecha ? new Date(ej.fecha).toLocaleString('es-MX') : ''} | {ej.duracion_segundos}s
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Chip icon={<CheckCircleIcon />} label={`${ej.passed} PASS`} size="small" sx={{ bgcolor: '#d1fae5', color: '#065f46', fontWeight: 700, fontSize: 11, '& .MuiChip-icon': { color: '#10b981' } }} />
                        {ej.failed > 0 && <Chip icon={<CancelIcon />} label={`${ej.failed} FAIL`} size="small" sx={{ bgcolor: '#fee2e2', color: '#991b1b', fontWeight: 700, fontSize: 11, '& .MuiChip-icon': { color: '#ef4444' } }} />}
                        {ej.warned > 0 && <Chip icon={<WarningAmberIcon />} label={`${ej.warned} WARN`} size="small" sx={{ bgcolor: '#fef3c7', color: '#92400e', fontWeight: 700, fontSize: 11, '& .MuiChip-icon': { color: '#f59e0b' } }} />}
                        <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#64748b' }}>
                          {ej.total} total
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </>
        )}

      </Box>

      {/* ══════════════════════════════════════════════════════════════ */}
      {/* DIALOG: CREATE/EDIT TEST */}
      {/* ══════════════════════════════════════════════════════════════ */}
      <StyledDialog
        open={showCreateDialog}
        onClose={() => setShowCreateDialog(false)}
        title={editingTest ? `Editar ${editingTest}` : formData.categoria_nombre ? `Nuevo test · ${formData.categoria_nombre}` : 'Nuevo Test'}
        icon={editingTest ? <EditIcon /> : <AddIcon />}
        variant="compact"
        maxWidth="xs"
      >
        {/* Close button */}
        <IconButton
          onClick={() => setShowCreateDialog(false)}
          sx={{ position: 'absolute', top: 8, right: 8, color: 'rgba(255,255,255,0.7)', zIndex: 1, '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.15)' } }}
          size="small"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>

        <StyledDialog.Body compact>
          {/* Row 1: ID + Category (only for new) */}
          {!editingTest && (
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField sx={{ ...inputStyles, flex: '0 0 100px' }} label="Test ID" value={formData.test_id} onChange={(e) => setFormData({ ...formData, test_id: e.target.value.toUpperCase() })} size="small" placeholder="SAL-06" />
              <TextField sx={{ ...inputStyles, flex: 1 }} label="Categoria" value={formData.categoria} onChange={(e) => setFormData({ ...formData, categoria: e.target.value })} size="small" placeholder="saludos" />
            </Box>
          )}
          {!editingTest && !formData.categoria_nombre && (
            <TextField sx={inputStyles} label="Nombre categoria" value={formData.categoria_nombre} onChange={(e) => setFormData({ ...formData, categoria_nombre: e.target.value })} size="small" placeholder="Saludos variados" fullWidth />
          )}

          {/* Test name */}
          <TextField sx={inputStyles} label="Nombre del test" value={formData.nombre} onChange={(e) => setFormData({ ...formData, nombre: e.target.value })} size="small" fullWidth placeholder="Descripcion corta del test" />

          {/* Messages - compact */}
          <Box>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#1e3a5f', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }}>Mensajes</Typography>
            {formData.mensajes.map((msg, i) => (
              <Box key={i} sx={{ display: 'flex', gap: 0.5, mb: 0.5, alignItems: 'center' }}>
                <Typography sx={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, width: 16, textAlign: 'center', flexShrink: 0 }}>{i + 1}</Typography>
                <TextField
                  sx={{ ...inputStyles, '& .MuiOutlinedInput-root': { ...inputStyles['& .MuiOutlinedInput-root'], fontSize: 12 } }}
                  value={msg}
                  onChange={(e) => { const m = [...formData.mensajes]; m[i] = e.target.value; setFormData({ ...formData, mensajes: m }); }}
                  size="small" fullWidth placeholder={`Mensaje del paciente`}
                />
                {formData.mensajes.length > 1 && (
                  <IconButton size="small" onClick={() => setFormData({ ...formData, mensajes: formData.mensajes.filter((_, j) => j !== i) })} sx={{ p: 0.25, color: '#cbd5e1', '&:hover': { color: '#ef4444' } }}>
                    <CancelIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                )}
              </Box>
            ))}
            <Button size="small" startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={() => setFormData({ ...formData, mensajes: [...formData.mensajes, ''] })} sx={{ textTransform: 'none', fontSize: 10, color: '#64748b', py: 0, minHeight: 24 }}>
              Agregar mensaje
            </Button>
          </Box>

          {/* Expectation */}
          <TextField sx={inputStyles} label="Expectativa" value={formData.espera} onChange={(e) => setFormData({ ...formData, espera: e.target.value })} size="small" multiline rows={2} fullWidth placeholder="Que debe hacer el bot con este mensaje" />

          {/* No debe contener - collapsible */}
          <Box>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#1e3a5f', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }}>No debe contener <Typography component="span" sx={{ fontSize: 10, color: '#94a3b8', fontWeight: 400, textTransform: 'none' }}>(opcional)</Typography></Typography>
            {formData.no_debe_contener.map((txt, i) => (
              <Box key={i} sx={{ display: 'flex', gap: 0.5, mb: 0.5, alignItems: 'center' }}>
                <TextField
                  sx={{ ...inputStyles, '& .MuiOutlinedInput-root': { ...inputStyles['& .MuiOutlinedInput-root'], fontSize: 12 } }}
                  value={txt}
                  onChange={(e) => { const a = [...formData.no_debe_contener]; a[i] = e.target.value; setFormData({ ...formData, no_debe_contener: a }); }}
                  size="small" fullWidth placeholder="Texto prohibido"
                />
                {formData.no_debe_contener.length > 1 && (
                  <IconButton size="small" onClick={() => setFormData({ ...formData, no_debe_contener: formData.no_debe_contener.filter((_, j) => j !== i) })} sx={{ p: 0.25, color: '#cbd5e1', '&:hover': { color: '#ef4444' } }}>
                    <CancelIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                )}
              </Box>
            ))}
            <Button size="small" startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={() => setFormData({ ...formData, no_debe_contener: [...formData.no_debe_contener, ''] })} sx={{ textTransform: 'none', fontSize: 10, color: '#64748b', py: 0, minHeight: 24 }}>
              Agregar
            </Button>
          </Box>

          {/* Pause - inline small */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: 11, color: '#64748b' }}>Pausa entre mensajes:</Typography>
            <TextField
              type="number" value={formData.pausa} onChange={(e) => setFormData({ ...formData, pausa: parseInt(e.target.value) || 3 })}
              size="small"
              sx={{ ...inputStyles, width: 70, '& .MuiOutlinedInput-root': { ...inputStyles['& .MuiOutlinedInput-root'], fontSize: 12 } }}
              InputProps={{ endAdornment: <Typography sx={{ fontSize: 10, color: '#94a3b8' }}>seg</Typography> }}
            />
          </Box>

          {/* AI Suggestion */}
          {!editingTest && formData.categoria && (
            <Button
              variant="outlined"
              startIcon={sugerenciaLoading ? <CircularProgress size={12} /> : <AutoAwesomeIcon sx={{ fontSize: 16 }} />}
              onClick={() => handleSugerirIA()}
              disabled={sugerenciaLoading}
              fullWidth
              sx={{
                textTransform: 'none', fontWeight: 600, fontSize: 11, borderRadius: 2, py: 0.75,
                borderColor: '#8b5cf6', color: '#8b5cf6',
                background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%)',
                '&:hover': { borderColor: '#7c3aed', bgcolor: 'rgba(139, 92, 246, 0.08)' },
                '&.Mui-disabled': { borderColor: '#e2e8f0', color: '#94a3b8' },
              }}
            >
              {sugerenciaLoading ? 'Generando...' : 'Sugerir con IA'}
            </Button>
          )}
          {sugerenciaRazon && (
            <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: 'rgba(139, 92, 246, 0.06)', border: '1px solid rgba(139, 92, 246, 0.15)' }}>
              <Typography sx={{ fontSize: 10, color: '#7c3aed', lineHeight: 1.4 }}>
                <AutoAwesomeIcon sx={{ fontSize: 11, verticalAlign: 'middle', mr: 0.5 }} />{sugerenciaRazon}
              </Typography>
            </Box>
          )}
        </StyledDialog.Body>
        <StyledDialog.CompactActions>
          <StyledDialog.CancelButton fullWidth onClick={() => setShowCreateDialog(false)} />
          <StyledDialog.PrimaryButton fullWidth onClick={handleCreateOrUpdate}>
            {editingTest ? 'Guardar' : 'Crear Test'}
          </StyledDialog.PrimaryButton>
        </StyledDialog.CompactActions>
      </StyledDialog>

      {/* ══════════════════════════════════════════════════════════════ */}
      {/* DIALOG: TEST DETAIL (StyledDialog) */}
      {/* ══════════════════════════════════════════════════════════════ */}
      <StyledDialog
        open={showDetalleDialog}
        onClose={() => setShowDetalleDialog(false)}
        title={detalleTest ? `${detalleTest.test_id}: ${detalleTest.nombre}` : ''}
        subtitle={detalleTest?.espera}
        icon={<ChatIcon />}
        chipLabel={detalleTest?.resultado?.resultado}
        maxWidth="md"
      >
        {detalleTest && (
          <>
            <StyledDialog.Body>
              {/* Messages sent */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#1e3a5f' }}>
                  Mensajes del test ({(detalleTest.mensajes || []).length})
                </Typography>
              </Box>
              {(detalleTest.mensajes || []).map((msg, i) => (
                <Box key={i} sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1, alignItems: 'center', gap: 0.5 }}>
                  {(detalleTest.mensajes || []).length > 1 && (
                    <Tooltip title="Eliminar mensaje">
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveMessage(detalleTest.test_id, detalleTest.mensajes, i)}
                        sx={{ color: '#cbd5e1', p: 0.25, '&:hover': { color: '#ef4444', bgcolor: '#fef2f2' } }}
                      >
                        <CancelIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Box sx={{
                    maxWidth: '80%', px: 1.5, py: 1, borderRadius: '12px 12px 4px 12px',
                    bgcolor: '#dcf8c6', border: '1px solid #c5e1a5',
                  }}>
                    <Typography sx={{ fontSize: 12, color: '#1b5e20', lineHeight: 1.4 }}>{msg}</Typography>
                  </Box>
                </Box>
              ))}
              {/* Add new message inline */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1, gap: 0.5 }}>
                <Box sx={{
                  display: 'flex', gap: 0.5, alignItems: 'center',
                  maxWidth: '80%', width: '80%',
                }}>
                  <TextField
                    value={nuevoMensaje}
                    onChange={(e) => setNuevoMensaje(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleAddMessage(detalleTest.test_id, detalleTest.mensajes); } }}
                    placeholder="Agregar mensaje..."
                    size="small"
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px', fontSize: 12, bgcolor: '#f0fdf4',
                        '& fieldset': { borderColor: '#c5e1a5' },
                        '&:hover fieldset': { borderColor: '#86efac' },
                        '&.Mui-focused fieldset': { borderColor: '#10b981' },
                      },
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={() => handleAddMessage(detalleTest.test_id, detalleTest.mensajes)}
                    disabled={!nuevoMensaje.trim()}
                    sx={{
                      bgcolor: nuevoMensaje.trim() ? '#10b981' : '#e2e8f0',
                      color: '#fff', p: 0.75,
                      '&:hover': { bgcolor: '#059669' },
                      '&.Mui-disabled': { bgcolor: '#e2e8f0', color: '#94a3b8' },
                    }}
                  >
                    <AddIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              </Box>

              {/* Bot responses */}
              {detalleTest.resultado?.respuestas?.length > 0 && (
                <>
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#1e3a5f', mb: 1, mt: 2 }}>Respuestas del bot</Typography>
                  {detalleTest.resultado.respuestas.map((r, i) => (
                    <Box key={i} sx={{ mb: 1.5 }}>
                      {/* User message */}
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.75 }}>
                        <Box sx={{ maxWidth: '75%', px: 1.5, py: 1, borderRadius: '12px 12px 4px 12px', bgcolor: '#dcf8c6', border: '1px solid #c5e1a5' }}>
                          <Typography sx={{ fontSize: 12, color: '#1b5e20', lineHeight: 1.4 }}>{r.mensaje_enviado}</Typography>
                        </Box>
                      </Box>
                      {/* Bot response */}
                      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Box sx={{ maxWidth: '85%', px: 1.5, py: 1, borderRadius: '12px 12px 12px 4px', bgcolor: '#fff', border: '1px solid #e0e0e0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.3 }}>
                            <ChatIcon sx={{ fontSize: 11, color: '#1e3a5f' }} />
                            <Typography sx={{ fontSize: 10, fontWeight: 700, color: '#1e3a5f' }}>Bot</Typography>
                          </Box>
                          <Typography sx={{ fontSize: 12, color: '#374151', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{r.respuesta_bot}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </>
              )}

              {/* Twilio intercepted */}
              {detalleTest.resultado?.twilio_interceptados?.length > 0 && (
                <>
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#1e3a5f', mb: 1, mt: 2 }}>Mensajes DIRECT-SEND</Typography>
                  {detalleTest.resultado.twilio_interceptados.map((m, i) => (
                    m.body && (
                      <Box key={i} sx={{ p: 1.5, mb: 1, borderRadius: 2, bgcolor: '#fffbeb', border: '1px solid #fde68a' }}>
                        <Typography sx={{ fontSize: 10, fontWeight: 700, color: '#92400e', mb: 0.3 }}>DIRECT-SEND</Typography>
                        <Typography sx={{ fontSize: 12, color: '#78350f', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{m.body}</Typography>
                      </Box>
                    )
                  ))}
                </>
              )}

              {/* Evaluation */}
              {detalleTest.resultado && (
                <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#1e3a5f', mb: 0.5 }}>Evaluacion</Typography>
                  <Typography sx={{ fontSize: 12, color: '#64748b' }}>{detalleTest.resultado.razon}</Typography>
                  <Typography sx={{ fontSize: 11, color: '#94a3b8', mt: 0.5 }}>Duracion: {detalleTest.resultado.duracion_ms}ms</Typography>
                </Box>
              )}

              {/* Criteria */}
              {(detalleTest.no_debe_contener?.length > 0 || detalleTest.debe_contener_alguno?.length > 0) && (
                <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#1e3a5f', mb: 0.5 }}>Criterios</Typography>
                  {detalleTest.no_debe_contener?.length > 0 && (
                    <Typography sx={{ fontSize: 11, color: '#64748b', mb: 0.25 }}>No debe contener: {detalleTest.no_debe_contener.map(t => `"${t}"`).join(', ')}</Typography>
                  )}
                  {detalleTest.debe_contener_alguno?.length > 0 && (
                    <Typography sx={{ fontSize: 11, color: '#64748b' }}>Debe contener alguno: {detalleTest.debe_contener_alguno.map(t => `"${t}"`).join(', ')}</Typography>
                  )}
                </Box>
              )}
            </StyledDialog.Body>
            <StyledDialog.Actions>
              <Button
                startIcon={<ContentCopyIcon sx={{ fontSize: 16 }} />}
                onClick={() => {
                  const text = formatTestForClipboard(detalleTest, detalleTest.resultado, selectedChatbot?.name);
                  navigator.clipboard.writeText(text).then(() => {
                    setSnackbar({ open: true, message: 'Resultado copiado', severity: 'success' });
                  });
                }}
                sx={{
                  borderRadius: 2, textTransform: 'none', fontWeight: 600, fontSize: 12,
                  color: '#1e3a5f', bgcolor: '#eff6ff', border: '1px solid #bfdbfe',
                  '&:hover': { bgcolor: '#dbeafe' },
                }}
              >
                Copiar para Claude
              </Button>
              <StyledDialog.CancelButton onClick={() => setShowDetalleDialog(false)}>Cerrar</StyledDialog.CancelButton>
            </StyledDialog.Actions>
          </>
        )}
      </StyledDialog>

      {/* ══════════════════════════════════════════════════════════════ */}
      {/* DIALOG: HISTORIAL DETAIL (StyledDialog) */}
      {/* ══════════════════════════════════════════════════════════════ */}
      <StyledDialog
        open={!!showHistorialDetalle}
        onClose={() => setShowHistorialDetalle(null)}
        title={showHistorialDetalle ? `Ejecucion #${showHistorialDetalle.id} - ${showHistorialDetalle.chatbot_nombre}` : ''}
        subtitle={showHistorialDetalle ? `${showHistorialDetalle.fecha ? new Date(showHistorialDetalle.fecha).toLocaleString('es-MX') : ''} | ${showHistorialDetalle.duracion_segundos}s` : ''}
        icon={<HistoryIcon />}
        maxWidth="lg"
      >
        {showHistorialDetalle && (
          <>
            <StyledDialog.Body>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <Chip icon={<CheckCircleIcon />} label={`${showHistorialDetalle.passed} PASS`} size="small" sx={{ bgcolor: '#d1fae5', color: '#065f46', fontWeight: 700, '& .MuiChip-icon': { color: '#10b981' } }} />
                {showHistorialDetalle.failed > 0 && <Chip icon={<CancelIcon />} label={`${showHistorialDetalle.failed} FAIL`} size="small" sx={{ bgcolor: '#fee2e2', color: '#991b1b', fontWeight: 700, '& .MuiChip-icon': { color: '#ef4444' } }} />}
                {showHistorialDetalle.warned > 0 && <Chip icon={<WarningAmberIcon />} label={`${showHistorialDetalle.warned} WARN`} size="small" sx={{ bgcolor: '#fef3c7', color: '#92400e', fontWeight: 700, '& .MuiChip-icon': { color: '#f59e0b' } }} />}
              </Box>

              {(showHistorialDetalle.resultados || []).map((r, i) => (
                <Box key={i} sx={{
                  mb: 1.5, p: 1.5, borderRadius: 2,
                  borderLeft: `3px solid ${r.resultado === 'PASS' ? '#10b981' : r.resultado === 'FAIL' ? '#ef4444' : '#f59e0b'}`,
                  bgcolor: r.resultado === 'PASS' ? '#f0fdf4' : r.resultado === 'FAIL' ? '#fef2f2' : '#fffbeb',
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography sx={{ fontSize: 12, fontWeight: 700, fontFamily: 'monospace', color: '#1e3a5f' }}>{r.test_id}</Typography>
                      <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#475569' }}>{r.nombre}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography sx={{ fontSize: 10, color: '#94a3b8' }}>{r.duracion_ms}ms</Typography>
                      <ResultChip resultado={r.resultado} />
                    </Box>
                  </Box>
                  {r.razon && <Typography sx={{ fontSize: 11, color: '#64748b' }}>{r.razon}</Typography>}
                  {r.respuestas?.map((resp, j) => (
                    <Box key={j} sx={{ mt: 1, pl: 2, borderLeft: '2px solid #e2e8f0' }}>
                      <Typography sx={{ fontSize: 11, color: '#3b82f6', fontWeight: 600 }}>{resp.mensaje_enviado}</Typography>
                      <Typography sx={{ fontSize: 11, color: '#475569', mt: 0.25 }}>{resp.respuesta_bot}</Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </StyledDialog.Body>
            <StyledDialog.Actions>
              <StyledDialog.CancelButton onClick={() => setShowHistorialDetalle(null)}>Cerrar</StyledDialog.CancelButton>
            </StyledDialog.Actions>
          </>
        )}
      </StyledDialog>

      {/* ══════════════════════════════════════════════════════════════ */}
      {/* DIALOG: ADD MESSAGE (compact) */}
      {/* ══════════════════════════════════════════════════════════════ */}
      <StyledDialog
        open={!!addMsgTarget}
        onClose={() => setAddMsgTarget(null)}
        title={addMsgTarget ? `Agregar mensaje a ${addMsgTarget.test_id}` : ''}
        icon={<AddCommentIcon />}
        variant="compact"
        maxWidth="xs"
      >
        {addMsgTarget && (
          <>
            <StyledDialog.Body compact>
              <Typography sx={{ fontSize: 11, color: '#64748b', mb: 0.5 }}>
                {addMsgTarget.nombre} — {addMsgTarget.mensajes.length} mensaje{addMsgTarget.mensajes.length !== 1 ? 's' : ''} actual{addMsgTarget.mensajes.length !== 1 ? 'es' : ''}
              </Typography>
              {/* Show existing messages as small chips */}
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1.5 }}>
                {addMsgTarget.mensajes.map((msg, i) => (
                  <Chip
                    key={i}
                    label={msg.length > 40 ? msg.substring(0, 40) + '...' : msg}
                    size="small"
                    sx={{ bgcolor: '#dcf8c6', color: '#1b5e20', fontSize: 10, fontWeight: 500, maxWidth: '100%', height: 22, '& .MuiChip-label': { px: 1 } }}
                  />
                ))}
              </Box>
              <TextField
                sx={inputStyles}
                label="Nuevo mensaje"
                value={nuevoMensaje}
                onChange={(e) => setNuevoMensaje(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey && nuevoMensaje.trim()) {
                    e.preventDefault();
                    handleAddMessage(addMsgTarget.test_id, addMsgTarget.mensajes);
                    setAddMsgTarget(prev => prev ? { ...prev, mensajes: [...prev.mensajes, nuevoMensaje.trim()] } : null);
                  }
                }}
                size="small"
                fullWidth
                multiline
                rows={2}
                placeholder="Escribe el mensaje que enviara el paciente..."
                autoFocus
              />
            </StyledDialog.Body>
            <StyledDialog.CompactActions>
              <StyledDialog.CancelButton fullWidth onClick={() => setAddMsgTarget(null)} />
              <StyledDialog.PrimaryButton
                fullWidth
                onClick={() => {
                  handleAddMessage(addMsgTarget.test_id, addMsgTarget.mensajes);
                  setAddMsgTarget(prev => prev ? { ...prev, mensajes: [...prev.mensajes, nuevoMensaje.trim()] } : null);
                }}
                disabled={!nuevoMensaje.trim()}
              >
                <SendIcon sx={{ fontSize: 16, mr: 0.5 }} /> Agregar
              </StyledDialog.PrimaryButton>
            </StyledDialog.CompactActions>
          </>
        )}
      </StyledDialog>

      {/* ── SNACKBAR ── */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: 2, fontSize: 13 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AdminTests;
